import axios from 'axios';
import SessionManager from 'utils/managers/sessionManager';

//TODO: handle request queues
class NetworkManager {
    constructor() {
        axios.defaults.headers.common['Accept'] =
            'application/vnd.bluechipapp.v2';
        axios.defaults.headers.common['Authorization'] =
            'Bearer ' + SessionManager.getAccessToken();
    }

    makeRequest = async (url, method, data = {}) => {
        const config = { url, method };
        console.log('NETWORK MANAGER DAYA', data);
        if (method === 'Get') {
            config.params = data;
        } else {
            config.data = { data: data };
        }
        try {
            console.log('CONFIG', config);
            const response = await axios.request(config);

            return response.data;
        } catch (error) {
            throw error;
        }
    };
    post = (url, data) => {
        const method = 'Post';
        return this.makeRequest(url, method, data);
    };
    put = (url, data) => {
        const method = 'Put';
        return this.makeRequest(url, method, data);
    };
    patch = (url, data) => {
        const method = 'Patch';
        return this.makeRequest(url, method, data);
    };
    get = (url, data) => {
        const method = 'Get';
        return this.makeRequest(url, method, data);
    };
}

const networkManager = new NetworkManager();

export default networkManager;



// WEBPACK FOOTER //
// ./src/utils/managers/NetworkManager.js